import { useEffect } from "react";

// Browser tab titles follow ui-ux-standard rule 13: most specific segment first, site name last,
// joined by " | ". Titles are section names only - never a patient, condition, medication, chat
// or document name, because titles persist in browser history, sync and screen shares (PHI).

export const SITE_NAME = "Medical Assistant";
const SEPARATOR = " | ";

/** Joins segments most-specific-first and appends the site name. Blank segments are dropped. */
export function formatPageTitle(...segments: Array<string | null | undefined>): string {
  const parts = segments
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => Boolean(segment));
  return [...parts, SITE_NAME].join(SEPARATOR);
}

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
